<template>

    <div :style="{width: `${width}px`, height: `${height}px`, color}">
        <icon :icon="icon" class="w-full" :class="currentType"></icon>
    </div>

</template>

<script>

    import Icon from 'laravel-mix-vue-svgicon/IconComponent.vue';

    export default {
        name: 'IconComponent',
        components: {Icon},

        props: {
            width: {
                type: Number,
                required: false,
                default: true
            },
            height: {
                type: Number,
                required: false,
                default: true
            },
            type: {
                type: String,
                required: false,
                default: 'fill',
                validator: (prop) => ['fill','stroke'].indexOf(prop) !== -1
            },
            color: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: true
            },
        },

        computed: {
            currentType() {
                return `${this.type}-current`;
            }
        }
    }

</script>
